module.exports = __webpack_public_path__ + "static/media/fast.dfba501c.png";